// Copyright ©️ 2026 eVolve MEP, LLC

type FontStyleFieldProps = {
  boldId: string;
  italicId: string;
  label: string;
  isBold: boolean;
  isItalic: boolean;
};

export const FontStyleField = ({ boldId, italicId, label, isBold, isItalic }: FontStyleFieldProps) => (
  <div className="field-wrapper">
    <div>{label}</div>
    <div className="button-group">
      <button id={boldId} className={`adsk-control adsk-button${isBold ? ' active' : ''}`} type="button" title="Bold">
        <i className="fas fa-bold" />
      </button>
      <button
        id={italicId}
        className={`adsk-control adsk-button${isItalic ? ' active' : ''}`}
        type="button"
        title="Italic"
      >
        <i className="fas fa-italic" />
      </button>
    </div>
  </div>
);
